'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: 32px;\n  cursor: pointer;\n'], ['\n  display: flex;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: 32px;\n  cursor: pointer;\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 8px;\n'], ['\n  margin-left: 8px;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _LinkMenu = require('../../atoms/LinkMenu');
var _LinkMenu2 = _interopRequireDefault(_LinkMenu);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var LinkMenuWithIcon = (0, _styledComponents2.default)(_LinkMenu2.default)(_templateObject);
var Linktext = _styledComponents2.default.span(_templateObject2);
var LinkBox = function LinkBox(props) {
  return _react2.default.createElement(LinkMenuWithIcon, {
    className: props.className,
    href: props.url,
    onClick: props.onClick
  }, props.children, _react2.default.createElement(Linktext, null, typeof props.innerRender === 'function' ? props.innerRender() : props.innerRender));
};
LinkBox.propTypes = {
  url: _propTypes2.default.string,
  innerRender: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
exports.default = LinkBox;